import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	.main-panel {
		width: 100%;
		height: 268px;
		background-color: #f6f6f6;
		padding: 40px 75px;
		position: relative;
		box-sizing: border-box;
		color: #000;
		.ant-btn {
			position: absolute;
			top: 40px;
			right: 110px;
			font-size: 22px;
			height: auto;
		}
		h2 {
			font-size: 35px;
			font-weight: bold;
			margin-bottom: 14px;
		}
		p {
			.advatages {
				text-indent: 12px;
				display: block;
			}
			.click {
				cursor: pointer;
				color: #5985ff;
				text-decoration: underline;
			}
		}
	}
	.member {
		padding: 32px 71px;
		.anticon {
			padding-right: 6px;
		}
		.btn-delete {
			text-decoration: underline;
			color: #5985ff;
			cursor: pointer;
		}
	}
	@media (max-width: 1200px) {
		z-index: 0;
		.member,
		.main-panel {
			padding: 24px;
			padding-left: 28px;
			h2 {
				font-size: 24px;
			}
		}
		.main-panel {
			font-size: 12px;
			.ant-btn {
				top: 33px;
				right: 8px;
			}
		}
	}
`;

export const ModalWrapper = styled.div`
	h3 {
		padding-top: 16px;
		font-size: 1.3rem;
		margin-bottom: 0;
	}
	p {
		padding-top: 0;
	}
	.confirm-mail {
		margin-top: 16px;
		padding-top: 0;
		border-radius: 8px;
		background-color: #e9e9e9;
		padding: 4px 8px;
		box-sizing: border-box;
	}
	.btn-area {
		margin-top: 12px;
		display: flex;
	}
	&.already-sent {
		text-align: center;
		h3 {
			padding-top: 16px;
			font-size: 1.3rem;
			margin-bottom: 0;
		}
		p {
			padding-top: 0;
		}
		.confirm-mail {
			margin-top: 0;
			background-color: #fff;
		}
	}
`;

export default Wrapper;
